module.exports = __webpack_public_path__ + "media/images/footer/WS-icon-linkedin_white-a4bb7a7860d12898e27cc112987fe8cd.svg";